const urlConstants = {
  REACT_APP_UI_ROOT_URI: "https://web.syncrocal.com",
  REACT_APP_SERVER_ROOT_URI: "https://backend.syncrocal.com",



}

export default urlConstants;
